import React from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Firebase from 'firebase';
import AddDataSets from './addDataSets';
import DsList from './dsList';
import AutoUpdate from './autoUpdate';
import XLSX from 'xlsx';


var ReactToastr = require("react-toastr");
var { ToastContainer } = ReactToastr;
var ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);

export default class datasets extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tab: "nuevo",
            button: "import"
        }
        this.renderList = this.renderList.bind(this);
        this.delete = this.delete.bind(this);
    }

    componentDidMount() {
        var datasetsRef = Firebase.database()
            .ref('datasets')
            .child(localStorage.client_id)
            .child("tablas");
        datasetsRef.on('value', snap => {
            this.setState({ datasets: snap.val() });
        })
    }

    delete(dataset) {
        var datasetsRef = Firebase.database()
            .ref('datasets')
            .child(localStorage.client_id);
        datasetsRef.child(dataset).remove().then(resp => {
            datasetsRef.child("tablas").child(dataset).remove().then(resp => {
                this.refs.container.success(
                    "Set de datos eleminado correctamente",
                    dataset, {
                        timeOut: 3000,
                        extendedTimeOut: 10000
                    });
            });
        });
    }

    renderList(tab) {
        switch (tab) {
            case "nuevo":
                return (
                    <div className="row">
                        <ToastContainer ref="container"
                            style={{ top: "60px" }}
                            toastMessageFactory={ToastMessageFactory}
                            className="toast-top-right"
                        />
                        <div className="col-md-3">
                            <div className="card">
                                <div className="card-header">
                                    <strong>Lista de Datos</strong>
                                </div>
                                <div className="card-block">
                                    <ul className="list-group">
                                        {
                                            this.state.datasets ?
                                                Object.values(this.state.datasets).map((d, index) => (
                                                    <li className="list-group-item d-flex justify-content-between align-items-center"
                                                        key={Object.keys(d)}
                                                    >
                                                        <a style={{ cursor: "pointer" }}
                                                            onClick={() => {
                                                                this.setState({ tab: "nuevo" });
                                                                this.setState({ tab: Object.keys(d)[0] !== "modified_at" ? Object.keys(d)[0] : Object.keys(d)[1], id: Object.keys(this.state.datasets)[index] })
                                                            }}>
                                                            {Object.keys(d)[0] !== "modified_at" ? Object.keys(d)[0] : Object.keys(d)[1]}
                                                        </a>
                                                        <span className="badge badge-default badge-pill">
                                                            <i className="fa fa-trash"
                                                                aria-hidden="true"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => this.delete(Object.keys(this.state.datasets)[index])}
                                                            />
                                                        </span>
                                                    </li>
                                                ))
                                                :
                                                ""
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-9">
                            <AddDataSets />
                        </div>
                    </div>
                );
            default:
                return (
                    <div>
                        <div className="row">
                            <div className="col col-xs-6 text-right">
                                <Modal isOpen={this.state.showModal} toggle={() => { this.setState({ showModal: !this.state.showModal }) }} className="modal-dialog modal-lg">
                                    <AutoUpdate />
                                </Modal>
                                <input
                                    style={{ display: "none" }}
                                    id="inputFile"
                                    type="file"
                                    accept=".xlsx,.xls"
                                    sheetName="input-file-preview"
                                    onChange={(e) => {
                                        this.setState({ file: e.target.files[0], button: "upload" });
                                    }}
                                />
                                <div className="form-group">
                                    {this.renderButton()}
                                    <button type="button" style={{ cursor: "pointer" }} onClick={() => this.setState({ showModal: true })} className="btn btn-outline-primary">Configurar</button>
                                    <button type="button" style={{ cursor: "pointer", position: "absolute", left: "15px" }} onClick={() => this.setState({ tab: "nuevo" })} className="btn btn-outline-warning">volver</button>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="text-center">
                            <DsList name={this.state.tab} id={this.state.id} />
                        </div>
                    </div>
                );
        }
    }

    filePicked() {
        const contex = this;
        // Get The File From The Input
        var oFile = this.state.file;
        var sFilesheetName = oFile.sheetName;
        var newPostKey = this.state.id;
        // Create A File Reader HTML5
        var reader = new FileReader();
        // Ready The Event For When A File Gets Selected
        reader.onload = function (e) {
            var data = e.target.result;
            var cfb = XLSX.read(data, { type: 'binary' });

            // Loop Over Each Sheet
            cfb.SheetNames.forEach(function (sheetName) {
                // Obtain The Current Row As CSV
                var dataSetRef = Firebase.database().ref('datasets').child(localStorage.client_id);
                var oJS = XLSX.utils.sheet_to_json(cfb.Sheets[sheetName]);
                var data = Object.values(oJS);
                var titles = [];
                Object.keys(data[0]).map((title, index) => {
                    var tt = "000" + index + "_" + title
                    titles.push(tt)
                })
                var arrData = [];
                data.map((filas, index) => {
                    var subData = {}
                    Object.values(filas).map((subFila, indexY) => {
                        subData[titles[indexY]] = subFila;
                    })
                    arrData.push(subData)
                })
                if (cfb.Strings.length >= 2) {
                    var nombre = sheetName.substring(0, sheetName.lastIndexOf('.'));
                    if (!nombre) {
                        nombre = sheetName;
                    }
                    console.log({ [nombre]: arrData }, sheetName)
                    dataSetRef.child(newPostKey).set({
                        [nombre]: arrData
                    }).then(resp => {
                        dataSetRef.child("tablas").child(newPostKey).set({
                            [nombre]: titles,
                            "modified_at": Firebase.database.ServerValue.TIMESTAMP
                        }).then(resp => {
                            contex.setState({ tab: "nuevo", button: "import" });
                            contex.refs.container.success(
                                "Fichero añadido correctamente",
                                "upload files.", {
                                    timeOut: 3000,
                                    extendedTimeOut: 10000
                                });
                        }).catch(err => {
                            contex.refs.container.warning(
                                "Fichero no fue añadido, verifique que contenga al menos dos columnas",
                                "upload files.", {
                                    timeOut: 3000,
                                    extendedTimeOut: 10000
                                });
                        });
                    }).catch(err => {
                        contex.setState({ button: "import" })
                    });
                }
            });
        };
        // Tell JS To Start Reading The File.. You could delay this if desired
        reader.readAsBinaryString(oFile);
    }

    renderButton() {
        switch (this.state.button) {
            case "import":
                return (
                    <button type="button" style={{ cursor: "pointer" }} onClick={() => { var l = document.getElementById('inputFile'); l.click(); }} className="btn btn-outline-success">Importar</button>
                )
            case "upload":
                return (
                    <div className="input-group image-preview" style={{ width: "15%", position: "absolute", margin: "auto", right: "164px" }}>
                        <input placeholder="" type="text" className="form-control image-preview-filesheetName"
                            value={this.state.file ? this.state.file.name : ""} disabled="disabled"
                        />
                        <span className="input-group-btn">
                            <button type="button" style={{ cursor: "pointer" }} onClick={() => { this.filePicked(); this.setState({ button: "uploading" }) }} className="btn btn-outline-success">Subir archivo</button>
                        </span>
                    </div >
                )
            case "uploading":
                return (
                    <button type="button" style={{ cursor: "pointer" }} onClick={() => { }} className="btn btn-outline-success">Subiendo <i className="fa fa-refresh fa-spin"></i></button>
                )
            default:
                break;
        }
    }

    render() {
        return (
            <div className="animated fadeIn">
                <div className="col-md-12">
                    {
                        this.renderList(this.state.tab)
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/datasets/datasets.js